import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { MainLayout } from '@/components/layout/MainLayout'
import LandingPage from '@/pages/LandingPage'
import { TransitionProvider } from '@/context/TransitionContext'
import { ContentProvider } from '@/content/ContentContext'

const BuilderPage  = lazy(() => import('@/pages/BuilderPage'))
const GalleryPage  = lazy(() => import('@/pages/GalleryPage'))
const ProductsPage = lazy(() => import('@/pages/ProductsPage'))
const BikeLinePage = lazy(() => import('@/pages/BikeLinePage'))
const AboutPage    = lazy(() => import('@/pages/AboutPage'))
const ContactPage  = lazy(() => import('@/pages/ContactPage'))
const LegalPage    = lazy(() => import('@/pages/LegalPage'))
const AdminPage    = lazy(() => import('@/pages/AdminPage'))

function BuilderFallback() {
  return (
    <div className="min-h-screen bg-carbon-900 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-gold-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-titanium-400 text-sm font-mono tracking-widest uppercase">
          Loading builder
        </p>
      </div>
    </div>
  )
}

export default function App() {
  return (
    <ContentProvider>
      <TransitionProvider>
    <Routes>
      {/* Pages using shared MainLayout (nav + footer) */}
      <Route element={<MainLayout />}>
        <Route index element={<LandingPage />} />
        <Route
          path="/gallery"
          element={
            <Suspense fallback={<div className="min-h-screen bg-carbon-900" />}>
              <GalleryPage />
            </Suspense>
          }
        />
        <Route
          path="/products"
          element={
            <Suspense fallback={<div className="min-h-screen bg-carbon-900" />}>
              <ProductsPage />
            </Suspense>
          }
        />
        <Route
          path="/bikes/:bikeId"
          element={
            <Suspense fallback={<div className="min-h-screen bg-carbon-900" />}>
              <BikeLinePage />
            </Suspense>
          }
        />
        <Route
          path="/about"
          element={
            <Suspense fallback={<div className="min-h-screen bg-carbon-900" />}>
              <AboutPage />
            </Suspense>
          }
        />
        <Route
          path="/contact"
          element={
            <Suspense fallback={<div className="min-h-screen bg-carbon-900" />}>
              <ContactPage />
            </Suspense>
          }
        />
        <Route
          path="/legal/:slug"
          element={
            <Suspense fallback={<div className="min-h-screen bg-carbon-900" />}>
              <LegalPage />
            </Suspense>
          }
        />
      </Route>

      {/* Builder — full-screen, no shared nav/footer */}
      <Route
        path="/builder"
        element={
          <Suspense fallback={<BuilderFallback />}>
            <BuilderPage />
          </Suspense>
        }
      />
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={<div className="min-h-screen bg-carbon-900" />}>
            <AdminPage />
          </Suspense>
        }
      />
    </Routes>
      </TransitionProvider>
    </ContentProvider>
  )
}
